// @core/api/endpoints/affiliate/list_campaigns.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListCampaignsResponse,
} from '../../../types/affiliate';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/affiliate';

/**
 * List campaigns
 * Returns a paginated list of campaigns. Supports filtering and sorting.
 */
export async function ListCampaigns(
  params?: PaginatedRequest & {
    affiliate_id?: string | number | boolean;
    offer_id?: string | number | boolean;
    status?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListCampaignsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/campaigns`;
  const requestOptions = options;
  return client.get<ListCampaignsResponse>(requestPath, { ...requestOptions, params });
}
